import { primaryPalette } from '../styles/theme';

export const RESET_PASSWORD_URL = 'set-password';

export const KADAR_LANDING = 'https://www.kadar.app/';

export const PRIVACY_POLICY_PAGE_URL = `${KADAR_LANDING}/privacy-and-cookie-policy`;

export const TERMS_OF_SERVICE_PAGE_URL = `${KADAR_LANDING}/terms-of-service`;

export const STRIPE_PRO_PRICE_ID =
  process.env.REACT_APP_STRIPE_BUSINESS_PRICE_ID;

export const ABSENCE_FEATURE_INITIAL_DATE = '01 Jan 2024';

export const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID;

export const LEVELING_AGENT_URL =
  process.env.REACT_APP_LEVELING_AGENT_URL || 'http://localhost:8081';

export const LEVELING_AGENT_ASSISTANT_ID =
  process.env.REACT_APP_LEVELING_AGENT_ASSISTANT_ID || 'leveling_agent';

export const BOOK_A_DEMO_LINK_PRICING =
  'https://calendly.com/kadar-demo/kadar-custom-solution-demo?utm_source=app&utm_medium=product&utm_campaign=app_demo&utm_content=pricing';

export const BOOK_A_DEMO_SIGN_UP =
  'https://calendly.com/kadar-demo/kadar-demo?utm_source=app&utm_medium=product&utm_campaign=app_demo&utm_content=sign_up';

export const GA_DEMO_EVENT_TRIGGER = 'gtm-sign-up-book-a-demo';
export const GA_CREATE_ORGANIZATION_TRIGGER = 'gtm-sign-up-create-organization';

export const SUBSCRIPTION_EXCLUDED_URLS = [`/pricing-plans`];

export const FEATURE_COLORS = {
  TO_DO: primaryPalette.blue1,
  PLANS: primaryPalette.pink1,
  COURSES: primaryPalette.bluish1,
  ONE_ON_ONE: primaryPalette.purple,
  TEAM: primaryPalette.yellow2,
  TASKS: primaryPalette.green1,
};
